/**
 * Main js file for widget display-post
 *
 * @package wordpress\sww
 * @since 1.0.0
 * @version 1.0.0
 */

'use strict';

/* global jQuery */
jQuery(function ($) {
  var tmp = $('div.sww-widget-display-post').parent();
  $(tmp).addClass('sww-widget-display-post-container');
  return;
});